export default "__VITE_ASSET__DNk_KpRw__"